import { render, staticRenderFns } from "./FlashCards.vue?vue&type=template&id=f0106a24&scoped=true&"
import script from "./FlashCards.vue?vue&type=script&lang=js&"
export * from "./FlashCards.vue?vue&type=script&lang=js&"
import style0 from "./FlashCards.vue?vue&type=style&index=0&id=f0106a24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0106a24",
  null
  
)

export default component.exports